<template>
  <button :type="type" :class="buttonClass" :data-test-id="dataTestId" :disabled="disabled">
    <yb-icon v-if="icon && !iconRight" :class="iconClass" :icon="icon" />
    <span v-if="label">{{ label }}</span>
    <slot v-else />
    <yb-icon v-if="icon && iconRight" class="!ml-2 !mr-0" :class="iconClass" :icon="icon" />
  </button>
</template>

<script>
import YbButtonMixin from './YbButtonMixin'

export default {
  name: 'YbButton',
  mixins: [YbButtonMixin],
  props: {
    type: {
      type: String,
      default: 'button'
    },
    iconRight: {
      type: Boolean,
      default: false
    }
  }
}
</script>
